import { getPatientCases } from "@repo/mdi";
import type { Case, CaseListData } from "..";
import { categorizeCases } from "./case-types";

/**
 * Fetches and categorizes patient cases from the provider network API.
 *
 * Handles the MDI pagination nesting (response.data.data) and categorizes
 * cases into current/past buckets via categorizeCases().
 *
 * @param patientId - The provider network patient ID
 * @returns Categorized case data with current and past arrays
 */
export async function fetchPatientCases(
  patientId: string
): Promise<CaseListData> {
  try {
    const response = await getPatientCases({
      path: { patient_id: patientId },
    });

    if (response.data) {
      // MDI API returns paginated responses with data nested inside
      const responseData =
        (response.data as { data: Case[] })?.data || [];
      const cases = Array.isArray(responseData) ? responseData : [];
      return categorizeCases(cases);
    }

    console.warn("No data returned from SDK, returning empty case list");
    return { current: [], past: [] };
  } catch (error) {
    console.error("Error fetching patient cases from SDK:", error);
    throw error;
  }
}
